export interface Lead {
  id: string;
  company: string;
  city: string;
  dot: string;
  mc: string;
  status: string;
  contactMethod?: string;
  interestedIn?: string;
  contactedDate?: string | undefined;
  isWarm?: boolean;
  hasComments: boolean;
  isProcessed: boolean;
  assignedTo?: string;
}

export interface DragItem {
  id: string;
  currentStatus: string;
}

export const ItemTypes = {
  LEAD: "lead",
};

export interface ProcessedLeadDto {
  id: string;
  leadId: string;
  date: Date;
  powerUnits?: number;
  trailerUnits?: number;
  company?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  contactName?: string;
  directPhone?: string;
  email?: string;
  fax?: string;
}

export interface LeadCommentsDto {
  id: string;
  processedLeadId: string;
  comment: string;
  commentedBy: string;
  date: Date;
}

export interface LeadMovementHistory {
  id: string;
  leadId: string;
  status: string;
  assignedTo?: string;
  changedAt: string;
}
